import {AppState} from 'store';

export const getStatus = (state: AppState) => state.main.status;
export const getStatusConnection = (state: AppState) => state.main.statusConnection;
export const getConnectionValidate = (state: AppState) => state.main.validConnection;
export const getTemplateData = (state: AppState) => state.main.templateData;
